import { StylesObject } from '../../types/styles'
import { SITE_VARIABLES, mq } from '../../themes/variables'
import { TeamObject } from '../../types/props'

export interface TradeStylesObject extends StylesObject {
    contentWrapper: StylesObject
    teamWrapper: StylesObject
    team: StylesObject
    teamTopic: StylesObject
    logo: StylesObject
    players: StylesObject
    subHead: StylesObject
    iconWrapper: StylesObject
    icon: StylesObject
}

export const getDefaultTradeStylesObj = (
    i: number,
    teams: TeamObject[],
    siteVars: typeof SITE_VARIABLES,
    preview: boolean | undefined,
): TradeStylesObject => {
    const { COLORS, TEXT_FONT_FAMILY } = siteVars
    const alignment = ['flex-start', 'flex-end', 'center']

    return {
        contentWrapper: {
            ...(!preview && {
                [mq[2]]: {
                    width: '45%',
                    margin: `${i === 2 ? '1rem auto 0' : ''}`,
                },
            }),
        },
        teamWrapper: {
            display: 'flex',
            position: 'relative',
            alignItems: 'center',
            width: '100%',
            marginBottom: '0.7rem',
            ...(!preview && {
                [mq[2]]: {
                    justifyContent: `${alignment[i]}`,
                },
            }),
        },
        team: {
            marginLeft: '0.5rem',
            ...(!preview && {
                [mq[2]]: {
                    marginLeft: '0',
                },
            }),
        },
        logo: {
            width: '45px',
            height: '45px',
            ...(!preview && {
                [mq[2]]: {
                    position: 'static',
                    width: '56px',
                    height: '56px',
                    transform: 'none',
                    marginRight: `${i === 1 ? '0' : '0.8rem'}`,
                    marginLeft: `${i === 1 ? '0.8rem' : ''}`,
                },
            }),
        },
        teamTopic: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            fontSize: '1.2rem',
            fontWeight: '800',
            position: 'relative',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            ...(!preview && {
                [mq[2]]: {
                    fontSize: '1.6rem',
                    margin: '0',
                    flexDirection: `${i === 1 ? 'row-reverse' : ''}`,
                    textAlign: `${i === 1 ? 'right' : ''}`,
                },
            }),
        },
        subHead: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            fontSize: '0.8rem',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            color: COLORS.MEDIUMGRAY,
        },
        players: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            fontSize: '1rem',
            lineHeight: '1.4',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            textAlign: 'center',
            textTransform: 'capitalize',
            ...(!preview && {
                [mq[2]]: {
                    textAlign: 'right',
                    alignItems: `${i !== 2 ? alignment[i] : ''}`,
                },
            }),
        },
        icon: {
            width: '2.5rem',
            margin: '1rem auto',
            ...(!preview && {
                [mq[2]]: {
                    alignSelf: 'center',
                    width: '3rem',
                },
            }),
        },
        iconWrapper: {
            display: `${teams.length !== i + 1 ? 'inline-block' : 'none'}`,
            ...(!preview && {
                [mq[2]]: {
                    display: `${i === 0 ? 'inline-block' : 'none'}`,
                },
            }),
        },
    }
}
